// this component is resposible for listing patient details in doctor section
import React, { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { Dropdown } from "react-bootstrap";

import "./component-styles.scss";

import newIcon from "../../../assets/newIcn.png";
import { filters } from "./constants";
import SelectedFilter from "./SelectedFilter";
import {
  dateFormatter,
  timeFormatter,
} from "../../../Util/Helper/dateManipulation";

const DoctorMyPatientsMainContent = ({
  patients,
  pageNumb,
  allDoctorsRelated,
  allDoctorsRelatedData,
  selectedDoctorsRelatedData,
  handleDoctorList,
  resetFilter,
  getAllDoctorsRelatedData,
  doctorFilterList,
  selectedDoctorFilter,
  selectedDoctorFilterDrop,
}) => {
  const [showFilterComponent, setShowFilterComponent] = useState(false);
  const [mobileFilter, setMobileFilter] = useState(false);
  const [mobileFilterData, setMobileFilterData] = useState(null);

  let is_staff = localStorage.getItem("user_type");

  const defaultSetUp = {
    show_upcoming: false,
    search_string: "",
    sort_by_latest: true,
    page_no: 1,
  };

  function renderAppointmentType(appointmentType) {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  }

  // function renderConsultationType(appointmentType, consultationType) {
  //   let appointmentTypeText =
  //     appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
  //   switch (consultationType) {
  //     case "regular":
  //       return <span>{appointmentTypeText + " Regular"}</span>;
  //     case "followup":
  //       return <span>{appointmentTypeText + " Follow-Up"}</span>;
  //     default:
  //       return "";
  //   }
  // }
  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (appointmentType) {
      case "online":
        if (consultationType === "instant") {
          return <span>Instant</span>;
        }
        if (consultationType === "followup") {
          return <span>{appointmentTypeText + " Follow-Up"}</span>;
        }
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "in-clinic":
        if (consultationType === "procedure") {
          return <span>{procedureName}</span>;
        }
        return <span>{appointmentTypeText + " Consultation"}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }

  function setdesciptionProps(patient) {
    localStorage.setItem("desciptionPropsDoctortId", patient.doctor_id);
    localStorage.setItem("desciptionPropsPatientId", patient.patient_id);
    localStorage.setItem(
      "desciptionPropsPatientAppointmentId",
      patient?.upcoming_appointment_id &&
        patient?.upcoming_appointment_id !== ""
        ? patient?.upcoming_appointment_id
        : patient?.last_appointment_id
    );
    localStorage.setItem("desciptionPropsPatientName", patient.patient_name);
    localStorage.setItem(
      "desciptionPropsPatientPhoneNo",
      patient.patient_phone_no
    );
    localStorage.setItem("desciptionPropsPatientPageNum", pageNumb);
    localStorage.setItem(
      "desciptionPropsPatientAcctId",
      patient.patient_account_id
    );
  }

  return (
    <div className="row mt-3 m-0 doctor_my_patient_main_table_cont bg_color_grey">
      <div className="col-12">
        <div className="row header m-0 mt-4 mb-2 d-none d-sm-none d-md-flex">
          <div className={`${is_staff === "staff" ? "col-md-2" : "col-md-3"}`}>
            Patient Details
          </div>

          <div className="col-md-3">Upcoming Appointment</div>
          <div className="col-md-2">Last Appointment</div>
          <div className={`${is_staff === "staff" ? "col-md-2" : "col-md-3"}`}>
            Last Diagnosis
          </div>
          <div className="col-md-1 pl-md-0">Actions</div>
        </div>
        <SelectedFilter
          // allDoctorsRelatedData={selectedDoctorFilter}
          handleDoctorList={handleDoctorList}
          mobileFilter={mobileFilter}
          mobileFilterData={mobileFilterData}
          selectedDoctorsRelatedData={selectedDoctorFilter}
          resetFilter={resetFilter}
        />
        {patients && patients.length > 0
          ? patients.map((patient, index) => (
              <div
                className="row m-0 mt-2 py-3 py-lg-2  appointment-row align-items-center"
                key={index}
              >
                <div
                  className={`${
                    is_staff === "staff"
                      ? "col-md-2 col-6 order-1"
                      : "col-md-3 col-6 order-1"
                  }`}
                >
                  <div className="d-flex flex-column">
                    <div className="header_no_display">
                      <p className="header m-0 mb-1">Patient DETAILS</p>
                    </div>
                    <div>
                      <p className="m-0" style={{ wordWrap: "break-word" }}>
                        {patient.patient_name}
                      </p>
                      <p className="m-0">{patient.patient_phone_no}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-1 col-6 p-lg-0 p-md-0 order-2 order-md-6 view_details_cont">
                  <div className="d-flex flex-column">
                    <div className="header_no_display">
                      <p className="header m-0 mb-1">View Details</p>
                    </div>
                    <div>
                      <Link
                        to={{
                          pathname:
                            "/doctor/account/mypatients/" +
                            `${
                              patient.patient_account_id
                                ? patient.patient_account_id
                                : patient.patient_id
                            }`,
                          state: {
                            desciptionProps: {
                              patient_id: patient.patient_id,
                              patient_appointment_id:
                                patient.last_appointment_id,
                              patient_name: patient.patient_name,
                              phone_no: patient.patient_phone_no,
                              pageNumb: pageNumb,
                            },
                          },
                        }}
                      >
                        <button
                          type="button"
                          className={`view-press-button rounded-pill secondary-button`}
                          data-tooltip="View Patient Details"
                          data-tooltip-conf="bottom"
                          onClick={() => setdesciptionProps(patient)}
                        >
                          <i className="fa fa-eye mx-1" aria-hidden="true"></i>
                          &nbsp;View
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-12 mt-3 mt-lg-0 order-3 order-md-3 d-flex flex-row justify-content-start align-items-center">
                  <div className="d-flex flex-column">
                    <div className="header_no_display">
                      <p className="header m-0 mb-1">UPCOMING APPOINTMENT</p>
                    </div>
                    <div className="d-flex">
                      {patient.upcoming_appointment_date ? (
                        <>
                          <div className="pr-2 border-right">
                            <p className="m-0">
                              {moment(patient.upcoming_appointment_date).format(
                                "DD MMM, YYYY"
                              )}
                            </p>
                            <p className="m-0">
                              {patient?.upcoming_appointment_start_time !==
                              "" ? (
                                <small>
                                  {moment(
                                    patient.upcoming_appointment_start_time,
                                    "hh:mm:ssZ"
                                  ).format("hh:mm A")}
                                </small>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                          <div className="pl-2">
                            {patient?.upcoming_appointment_consultation_type !==
                            "instant" ? (
                              <>
                                <p className="m-0">
                                  {renderAppointmentType(
                                    patient.upcoming_appointment_type
                                  )}
                                </p>
                                <p className="m-0">
                                  <small>
                                    {renderConsultationType(
                                      patient.upcoming_appointment_type,
                                      patient.upcoming_appointment_consultation_type,
                                      patient.upcoming_appointment_procedure_name
                                    )}
                                  </small>
                                </p>
                              </>
                            ) : (
                              <p className="m-0">
                                {renderConsultationType(
                                  patient.last_appointment_consultation_type
                                )}
                              </p>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="no-result">No Appointment</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-2 col-6 order-4 my-3 my-lg-0">
                  <div className="d-flex flex-column">
                    <div className="header_no_display">
                      <p className="header m-0 mb-1">Last Appointment</p>
                    </div>
                    <div>
                      {patient.last_appointment_date ? (
                        <>
                          <p className="m-0">
                            {patient?.last_appointment_mark_check_in_time !== ""
                              ? dateFormatter(
                                  patient?.last_appointment_mark_check_in_time
                                )
                              : moment(patient.last_appointment_date).format(
                                  "DD MMM, YYYY"
                                )}
                          </p>
                          {patient?.last_appointment_mark_check_in_time !==
                          "" ? (
                            <p className="m-0">
                              <small>
                                {timeFormatter(
                                  patient.last_appointment_mark_check_in_time
                                )}
                              </small>
                            </p>
                          ) : patient.last_appointment_start_time != "" ? (
                            <p className="m-0">
                              <small>
                                {moment(
                                  patient.last_appointment_start_time,
                                  "hh:mm:ssZ"
                                ).format("hh:mm A")}
                              </small>
                            </p>
                          ) : (
                            <p>-</p>
                          )}
                        </>
                      ) : (
                        <div className="no-result">No Appointment</div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={`${
                    is_staff === "staff"
                      ? "col-md-2 col-6 order-5"
                      : "col-md-3 col-6 order-5"
                  }`}
                >
                  <div className="d-flex flex-column">
                    <div className="header_no_display">
                      <p className="header m-0 mb-1">Last diagnosis</p>
                    </div>
                    <div className="diagnosis_text_2_line">
                      {patient.last_diagnosis &&
                      patient.last_diagnosis.split("<br>")[0].trim() !== "" ? (
                        patient.last_diagnosis.split("<br>")[0]
                      ) : (
                        <span className="no-result">{"No diagnosis"}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          : ""}
      </div>
    </div>
  );
};

export default DoctorMyPatientsMainContent;
